const validator = require('validator');
const { getDay, getFullYearAsString, getMonth } = require('utilities/dateHelper/dateHelper');

function checkAscDescValue(value) {
    const asc = '0123456789';
    const des = '9876543210';

    return asc.includes(value) || des.includes(value);
}

function checkSameDigitsValue(value) {
    const valueArray = value.split('');

    return !!valueArray.find(
        (item, index) =>
            item === valueArray[index + 1] && item === valueArray[index + 2] && item === valueArray[index + 3]
    );
}

function checkNumeric(value) {
    return !(validator.matches(value, /^[0-9]{4}$/) && value.length === 4);
}

function getSeparatedDate(date) {
    return {
        day: getDay(date),
        month: getMonth(date),
        year: getFullYearAsString(date),
    };
}

export default { checkAscDescValue, checkSameDigitsValue, checkNumeric, getSeparatedDate };
